import { actionSetErrorMessage, AppMessagesContext, SessionContext } from '@viamap/viamap2-common';
import { ReactElement, useCallback, useContext, useReducer } from 'react';
import { GenericTransactionManager, initialJobState, JobActions, JobsContext, transactionalJobsReducer, JobState, JobsReducer, JobActionType } from './JobState';
import { JobTypePersistence } from './JobDataStore';

export function JobModuleManager(props: { children: ReactElement }) {
   let { state: sessionState } = useContext(SessionContext);
   let { dispatch: appMessageDispatch } = useContext(AppMessagesContext);

   // Save State
   let PersistenceReducer = useCallback((state: JobState, action: JobActions) => {
      let nextState = JobsReducer(state, action);
      asyncPersistenceReducer(state, nextState, action);
      return nextState
   }, [sessionState.customerRef, sessionState.userRef])

   const [JobState, JobDispatch] = useReducer(PersistenceReducer, initialJobState());

   function asyncPersistenceReducer(oldState: JobState, nextState: JobState, action: JobActions) {
      switch (action.type) {

         case JobActionType.AddJobType: {
            JobTypePersistence.getInstance().createObject(action.payload.item)
               .catch((reason) => {
                  appMessageDispatch(actionSetErrorMessage("Failed to add JobType: " + reason.message))
               })
            break;
         }

         case JobActionType.UpdateJobType:
            {
               JobTypePersistence.getInstance().saveObject(action.payload.item)
                  .catch((reason) => {
                     appMessageDispatch(actionSetErrorMessage("Failed to update JobType: " + reason.message))
                  })
               break;
            }

         case JobActionType.DeleteJobType: {
            JobTypePersistence.getInstance().deleteObject(action.payload.id)
               .catch((reason) => {
                  appMessageDispatch(actionSetErrorMessage("Failed to delete JobType: " + reason.message))
               })
            break;
         }


         default: {
            // No persistence needed
         }
      }
   }

   return (
      <JobsContext.Provider
         value={{
            state: JobState,
            dispatch: GenericTransactionManager.dispatchMiddleware<JobActions>(JobDispatch, transactionalJobsReducer),
         }}
      >
         {props.children}
      </JobsContext.Provider>
   )
}





